<template>
  <v-row>
    <v-col>
      <div class="subtitle-1 primary--text font-weight-bold">
        {{ question.question }}
      </div>
      <v-row>
        <v-col cols="auto">
          <div v-if="question.answer">
            <v-icon
              small
              color="success"
            >
              fiber_manual_record
            </v-icon>
            Published
          </div>
          <div v-else>
            <v-icon
              small
              color="warning"
            >
              fiber_manual_record
            </v-icon>
            Pending
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-spacer class="limited-spacer" />
    <v-col cols="auto">
      <v-menu absolute>
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            :loading="saving"
            v-on="on"
            @click.prevent
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-title> Edit </v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteQuestion">
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <EditQuestion @save="$emit('save')" />
  </v-row>
</template>

<script>
import EditQuestion from '@/components/content/catalog/EditQuestion';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogSimpleQuestion',

  components: { EditQuestion },

  props: { question: { type: Object } },

  data() {
    return {
      valid: false,
      saving: false,
      drawer: false,
      tab: 0
    };
  },

  computed: {
    page() {
      if (this.question.catalogContentPageId) {
        return this.catalog_page;
      }
      return null;
    },
    ...mapGetters({
      catalog_page: 'catalogPages/edit_catalog_page'
    })
  },

  methods: {
    edit() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_QUESTION_SHOW, {
        question: this.question
      });
    },
    async deleteQuestion() {
      if (
        await this.$root.$confirm(
          'Delete Question',
          'Are you sure you want to delete this question?',
          { color: 'error' }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch('content/deleteCatalogQuestion', this.question.id)
          .then(() => {
            this.$emit('save');
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
